import { actionEmitter, EmitEvent } from "../config/ActionEmitter";
import { IApiResponse } from "../models/Interfaces";
import { AjaxService } from "./AjaxService";
import { SiteSwitcher } from "./SiteSwitcher";
import { TokenService } from "./TokenService";

export class BaseService {
  protected _ajaxService: AjaxService;
  protected _siteSwitcher: SiteSwitcher;
  protected _tokenService: TokenService;

  constructor() {
    this._ajaxService = new AjaxService();
    this._siteSwitcher = new SiteSwitcher();
    this._tokenService = new TokenService();
  }

  get siteKey(): string | null {
    return this._siteSwitcher.getSelectedSiteKey() ?? null;
  } 

  get userId(): string | null {
    const userid = this._tokenService.getUserId();
    return userid;
  }

  public EmitDataError =(result: IApiResponse | null | undefined, fallbackmessage: string) : void => {
    actionEmitter.emit(EmitEvent.Result, result?.Success ?? false, result?.Messages?.[0] ?? fallbackmessage);
  }

  public EmitDataSuccess = (message: string) : void => {
    actionEmitter.emit(EmitEvent.Result, true, message);
  }
}